import React from "react";

import {
  FiRotateCcw,
  FiSearch,
} from "react-icons/fi";

export default function SiteActivityFilters({
  filters,
  updateFilter,
  resetFilters,

  productOptions,

  sortKey,
  sortDir,

  setQuickSortKey,
}) {
  return (
    <div className="rounded-[24px] border border-slate-200 bg-[#F8FBFD] p-4 dark:border-slate-800 dark:bg-slate-950/40">
      <div className="grid grid-cols-1 gap-3 lg:grid-cols-12">
        <div className="lg:col-span-3">
          <label className="text-xs font-bold uppercase tracking-[0.12em] text-slate-400">
            Recherche
          </label>

          <div className="mt-1 flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-3 py-2 dark:border-slate-700 dark:bg-slate-900">
            <FiSearch className="text-slate-400" />

            <input
              value={
                filters.search
              }
              onChange={(
                event,
              ) =>
                updateFilter(
                  "search",
                  event.target
                    .value,
                )
              }
              placeholder="Nom, produit, URL..."
              className="w-full bg-transparent text-sm text-slate-700 outline-none placeholder:text-slate-400 dark:text-slate-100"
            />
          </div>
        </div>

        <div className="lg:col-span-2">
          <label className="text-xs font-bold uppercase tracking-[0.12em] text-slate-400">
            Produit
          </label>

          <select
            value={
              filters.productKey
            }
            onChange={(
              event,
            ) =>
              updateFilter(
                "productKey",
                event.target.value,
              )
            }
            className="mt-1 w-full rounded-2xl border border-slate-200 bg-white px-3 py-2.5 text-sm font-semibold text-slate-700 outline-none dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100"
          >
            {productOptions.map(
              (option) => (
                <option
                  key={
                    option.value
                  }
                  value={
                    option.value
                  }
                >
                  {
                    option.label
                  }
                </option>
              ),
            )}
          </select>
        </div>

        <div className="lg:col-span-2">
          <label className="text-xs font-bold uppercase tracking-[0.12em] text-slate-400">
            Surveillance
          </label>

          <select
            value={
              filters.monitorStatus
            }
            onChange={(
              event,
            ) =>
              updateFilter(
                "monitorStatus",
                event.target.value,
              )
            }
            className="mt-1 w-full rounded-2xl border border-slate-200 bg-white px-3 py-2.5 text-sm font-semibold text-slate-700 outline-none dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100"
          >
            <option value="all">
              Tous
            </option>

            <option value="ok">
              Surveillé
            </option>

            <option value="warning">
              À vérifier
            </option>

            <option value="offline">
              Indisponible
            </option>

            <option value="stats_only">
              Stats seules
            </option>
          </select>
        </div>

        <div className="lg:col-span-2">
          <label className="text-xs font-bold uppercase tracking-[0.12em] text-slate-400">
            Tri rapide
          </label>

          <select
            value={sortKey}
            onChange={(
              event,
            ) =>
              setQuickSortKey(
                event.target.value,
              )
            }
            className="mt-1 w-full rounded-2xl border border-slate-200 bg-white px-3 py-2.5 text-sm font-semibold text-slate-700 outline-none dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100"
          >
            <option value="visitsToday">
              Visites du jour
            </option>

            <option value="visitsTotal">
              Visites totales
            </option>

            <option value="totalUsers">
              Utilisateurs
            </option>

            <option value="adherents">
              Adhérents
            </option>

            <option value="inscrits">
              Inscrits
            </option>

            <option value="requestsPending">
              Requêtes
            </option>

            <option value="name">
              Nom
            </option>

            <option value="productLabel">
              Produit
            </option>
          </select>
        </div>

        <div className="flex flex-col justify-end gap-2 lg:col-span-2">
          <label className="inline-flex items-center gap-2 text-sm font-semibold text-slate-600 dark:text-slate-300">
            <input
              type="checkbox"
              checked={
                filters.onlyWithAlerts
              }
              onChange={(
                event,
              ) =>
                updateFilter(
                  "onlyWithAlerts",
                  event.target
                    .checked,
                )
              }
            />

            Avec alertes
          </label>

          <label className="inline-flex items-center gap-2 text-sm font-semibold text-slate-600 dark:text-slate-300">
            <input
              type="checkbox"
              checked={
                filters.onlyWithRequests
              }
              onChange={(
                event,
              ) =>
                updateFilter(
                  "onlyWithRequests",
                  event.target
                    .checked,
                )
              }
            />

            Avec requêtes
          </label>
        </div>

        <div className="flex items-end lg:col-span-1">
          <button
            type="button"
            onClick={
              resetFilters
            }
            className="inline-flex w-full items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-3 py-2.5 text-sm font-bold text-slate-600 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200"
          >
            <FiRotateCcw />

            Reset
          </button>
        </div>
      </div>

      <div className="mt-3 text-xs text-slate-400">
        Tri actuel :{" "}
        <span className="font-bold">
          {sortKey}
        </span>{" "}
        <span>
          {sortDir === "asc"
            ? "↑"
            : "↓"}
        </span>
      </div>
    </div>
  );
}